import { render, staticRenderFns } from "./LocationCard.vue?vue&type=template&id=4b4cd47e&"
import script from "./LocationCard.vue?vue&type=script&lang=js&"
export * from "./LocationCard.vue?vue&type=script&lang=js&"
import style0 from "./LocationCard.vue?vue&type=style&index=0&id=4b4cd47e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonIcon: require('/opt/build/repo/node_modules/@pleinair/bigcolony-vue/components/common/Icon/index.vue').default,LocationsSearchElementsOperationInfo: require('/opt/build/repo/node_modules/@pleinair/bigcolony-vue/components/locations/search/elements/OperationInfo.vue').default,LocationsSearchElementsAddressInfo: require('/opt/build/repo/node_modules/@pleinair/bigcolony-vue/components/locations/search/elements/AddressInfo.vue').default})
